import { Component, Inject, Injectable } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { firstValueFrom } from "rxjs";

@Component({
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `<h2 mat-dialog-title>{{ data.header }}</h2>
    <mat-dialog-content *ngIf="data.message">{{
      data.message
    }}</mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="'cancel'">
        {{ data.cancel }}
      </button>
      <button mat-flat-button [mat-dialog-close]="'confirm'">
        {{ data.confirm }}
      </button>
    </mat-dialog-actions>`,
})
export class ProductConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}

/** Keeps the existing product confirmation callbacks while rendering a Material dialog. */
@Injectable({ providedIn: "root" })
export class ProductConfirmationService {
  constructor(private dialog: MatDialog) {}

  async create(options: any) {
    let dismissed: Promise<{ role: string }>;
    const cancel = options.buttons.find(
      (button: any) => button.role === "cancel",
    );
    const confirm = options.buttons.find(
      (button: any) => button.role !== "cancel",
    );
    return {
      present: async () => {
        const ref = this.dialog.open(ProductConfirmDialogComponent, {
          width: "420px",
          maxWidth: "calc(100vw - 32px)",
          data: {
            header: options.header,
            message: options.message,
            cancel: cancel?.text || "Cancel",
            confirm: confirm?.text || "Confirm",
          },
        });
        dismissed = firstValueFrom(ref.afterClosed()).then((role) => {
          const button = role === "confirm" ? confirm : cancel;
          button?.handler?.();
          return { role: role || "cancel" };
        });
      },
      onDidDismiss: () => dismissed,
    };
  }
}
